import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  userAccessRightsSuccess,
  userLoginErrorMsg,
  userLoginSuccessMsg,
  userProfileFetchSuccess,
} from "./reducer";
import { loginApi, logoutApi, verifyOtpApi } from "services/authServcies";
import { useNavigate } from "react-router-dom";
// Utility to normalize error object
const formatError = (error: any): { data: string } => ({
  data:
    error?.response?.data?.message ||
    error?.message ||
    "Something went wrong. Please try again.",
});

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const response = await loginApi({
      phoneno: user.phoneno,
      countrycode: user.countrycode,
      dialcode: user.dialcode,
      languageid: user.languageid || 1,
    });

    if (response.success) {
      // Show success message
      dispatch(userLoginSuccessMsg(response.message || "OTP sent successfully"));

      // Store phone number for OTP verification
      sessionStorage.setItem("phoneNumber", user.phoneno);
      sessionStorage.setItem("countrycode", user.countrycode);
      sessionStorage.setItem("dialcode", user.dialcode);

      // Navigate to OTP verification page (Login OTP page)
      history("/login-otp");

      // Clear login flags after delay
      setTimeout(() => {
        dispatch(reset_login_flag());
      }, 5000);
    } else {
      dispatch(apiError({ data: "OTP request failed" }));
      dispatch(userLoginErrorMsg(response.message || "Please check your phone number"));
    }
  } catch (loginError: any) {
    const errorMessage = "OTP request error. Please try again.";
    dispatch(userLoginErrorMsg(loginError?.response?.data?.message || errorMessage));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    const response = {
      success: true
    };

    if (response?.success) {
      sessionStorage.removeItem("authUser");  
      sessionStorage.removeItem("isLoggedIn");  
      localStorage.setItem("logout", Date.now().toString()); // signal other tabs
      dispatch(logoutUserSuccess());
      return "Logout successful";
    } else {
      dispatch(apiError({ data: "Logout failed" }));
    }
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};

// Example placeholder for social login (optional)
export const socialLogin = (type: any, history: any) => async (dispatch: any) => {
  const navigate = useNavigate()
  try {
    // Simulated response (replace with actual logic)
    let response; // Placeholder
    const socialdata = await response;

    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      navigate("/explore-courses");
    }
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};

// Login OTP Verification Thunk
export const verifyLoginOtp = (data: {
  phoneno: string;
  dialcode: string;
  countrycode: string;
  otp: string;
}) => async (dispatch: any) => {
  try {
    const response = await verifyOtpApi(data);

    if (response.success) {
      // Store tokens if provided
      if (response.data?.token && response.data?.refresh_token) {
        const authData = {
          token: response.data.token,
          refresh_token: response.data.refresh_token,
          user: response.data.user || {},
          username: response.data.user?.phone_no || data.phoneno,
          phone_no: response.data.user?.phone_no || data.phoneno,
          email_id: response.data.user?.email_id || '',
        };
        sessionStorage.setItem("authUser", JSON.stringify(authData));
        sessionStorage.setItem("isLoggedIn", "true");
        dispatch(loginSuccess());
        dispatch(userProfileFetchSuccess({
          username: authData.username,
          phone_no: authData.phone_no,
          email_id: authData.email_id,
        }));
      }

      dispatch(userLoginSuccessMsg(response.message || "Login successful"));
      return { success: true, data: response.data };
    } else {
      dispatch(userLoginErrorMsg(response.message || "Invalid OTP. Please try again."));
      return { success: false, message: response.message };
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      "OTP verification failed. Please try again.";
    dispatch(userLoginErrorMsg(errorMessage));
    return { success: false, message: errorMessage };
  }
};
